import ItemWrapper from '@/src/components/Layouts/Item/Item';
import React from 'react';
import { Form } from 'src/components/Antd';
import { Language } from 'src/constrains/AdvancedFilters/Components';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/CustomerDatabaseConfig/CustomerTag/Detail/Filters/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import { Clear } from '../Components';
const Item = Form.Item;

//name,options
const _Language = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { name, options, root, form, state, disabled } = props;

  return (
    <SectionWrapper title={getI18n('customerTag.language.language')}>
      <ItemWrapper title=''>
        <Language name={name} options={options} disabled={disabled} />
        <Item
          shouldUpdate={(p, c) => {
            const touched = form.isFieldTouched(root);
            return touched; //|| cv !== pv;
          }}>
          {(f) => {
            const { getFieldValue } = f;

            const hasValue = (getFieldValue(name) || []).length > 0;

            if (hasValue) {
              return (
                <Clear
                  disabled={disabled}
                  onClick={() => {
                    form.setFieldsValue(state);
                  }}
                />
              );
            }
          }}
        </Item>
      </ItemWrapper>
    </SectionWrapper>
  );
};
export default _Language;
